import { Injectable } from '@angular/core';
import { Collection, CollectionModel, CrudService, Item, ItemModel } from 'collection';
import { BehaviorSubject, Observable } from 'rxjs';
import { SettingsService } from '@features/settings/settings.service';
import { TimeService } from '@services/common/time.service';

@Injectable({
  providedIn: 'root'
})
export class AbsenceService {
  isOpenSidebar: boolean = true;
  absenceRequestsCollection: CollectionModel;
  absenceListCollection: CollectionModel;
  employeesCollection: CollectionModel;
  absencePlannerCollection: CollectionModel;
  absenceMyAbsenceCollection: CollectionModel;
  absenceSummaryCollection: CollectionModel;
  absenceCollection: Collection;
  absenceItem: ItemModel;
  workersCollection: CollectionModel;

  private _isOpenSidebar: BehaviorSubject<boolean> = new BehaviorSubject(this.isOpenSidebar);

  get $isOpenSidebar(): Observable<any> {
    return this._isOpenSidebar.asObservable();
  }

  toggleSidebar(): boolean {
    this.isOpenSidebar = !this.isOpenSidebar;
    this._isOpenSidebar.next(this.isOpenSidebar);
    return this.isOpenSidebar;
  }

  setDetailsData(absences_per_year: number): { days: number; remainder: string } {
    const settingsDefaultWorkingHours = this._additionalSettings.additionalSettings$.value['default_working_hours'];
    const defaultDayDurationInMinutes = this._timeService.timeToMinutes(settingsDefaultWorkingHours);
    return this._timeService.getWorkingDays(absences_per_year, defaultDayDurationInMinutes);
  }

  constructor(
    private _crud: CrudService,
    private _additionalSettings: SettingsService,
    private _timeService: TimeService
  ) {
    this.absenceRequestsCollection = new Collection({
      api: this._crud.createEntity({ name: 'absence' }),
      params: {
        status: 'new',
        expand: 'absenceType,user.avatars,hours'
      }
    });

    this.absenceListCollection = new Collection({
      api: this._crud.createEntity({ name: 'absence' }),
      params: {
        status: 'approved',
        expand: 'absenceType,user,hours'
      }
    });

    this.absenceCollection = new Collection({
      api: this._crud.createEntity({ name: 'absence' }),
      params: {
        expand: 'absenceType,user'
      }
    });

    this.absenceCollection.hardReloadAfter.deleting = false;
    this.absenceCollection.setParams('per_page', 9999);

    this.employeesCollection = new Collection({
      api: this._crud.createEntity({ name: 'worker' }),
      params: {
        expand: 'full_name,avatars,absences_per_year',
        status: 'active'
      }
    });

    this.employeesCollection.mapItems = (item) => ({
      ...item,
      absences_per_year_display_value: this._additionalSettings.additionalSettings$.value
        ? this.setDetailsData(item.absences_per_year)
        : null
    });

    this.absencePlannerCollection = new Collection({
      api: this._crud.createEntity({ name: 'absence/time-sheet' })
    });

    this.absencePlannerCollection.setParams('per_page', 9999);

    this.absenceMyAbsenceCollection = new Collection({
      api: this._crud.createEntity({ name: 'absence/time-sheet' })
    });

    this.absenceMyAbsenceCollection.setParams('per_page', 9999);

    this.absenceSummaryCollection = new Collection({
      api: this._crud.createEntity({ name: 'absence/summary' })
    });

    this.absenceItem = new Item({
      api: this._crud.createEntity({ name: 'absence' }),
      params: {
        expand: 'absenceType,user'
      }
    });

    this.workersCollection = new Collection({
      api: this._crud.createEntity({ name: 'worker' }),
      params: {
        status: 'active',
        expand: 'full_name,avatars,wages',
        sort: 'first_name',
        per_page: 30
      }
    });
  }
}
